import { t } from "@lingui/macro";
import { deepSearchAndParseDates, ErrorMessage } from "@reactive-resume/utils";
import _axios from "axios";

import { toast } from "../hooks/use-toast";
import { translateError } from "../services/errors/translate-error";

export const axios = _axios.create({ baseURL: "/api", withCredentials: true });

// Intercept responses to transform ISO dates to JS date objects
axios.interceptors.response.use(
  (response) => {
    const transformedResponse = deepSearchAndParseDates(response.data, ["createdAt", "updatedAt"]);
    return { ...response, data: transformedResponse };
  },
  (error) => {
    const message = error.response?.data.message as ErrorMessage;
    const description = translateError(message);

    if (description) {
      toast({
        variant: "error",
        title: t`Oops, the server returned an error.`,
        description,
      });
    }

    return Promise.reject(new Error(message));
  },
);

// Final interceptor: if backend says user has no active subscription, redirect them externally
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = (error?.response?.data?.message as ErrorMessage | undefined) ?? error?.message;
    if (message === "Forbidden resource" || message === ErrorMessage.SubscriptionNotFound) {
      // External redirect for non-premium users
      window.location.assign("https://student.hi-interns.com/api/redirect/hi-resume");
      // Return a plain Error to avoid triggering auth-refresh on 401 again
      return Promise.reject(new Error(message));
    }
    // Pass through untouched so upper interceptors (like auth-refresh) can process it
    return Promise.reject(error instanceof Error ? error : new Error(String(error?.message ?? "")));
  },
);
